module.exports = __webpack_public_path__ + "static/fireworks-right-cc2435da19e8419eb8d91ed0ccb78454.png";